import Cookies from 'js-cookie';
import { AIDT_ACCESS_ID } from '@shared/constants/token';

export function isAIDTUser() {
  return !!Cookies.get(AIDT_ACCESS_ID);
}
